module.exports = __webpack_public_path__ + "32c97a9ecdd3f3c1a26dd0ea06903f77.pdf";